import { useTranslation } from '@mc/i18n'

type ThankYouProps = {
  descriptionText?: string
}

const ThankYou = ({ descriptionText }: ThankYouProps) => {
  const { t } = useTranslation('@mc/next')

  return (
    <div className='mc-text--center mc-animation--show mc-animation--animating'>
      <h2 className='mc-text-h4'>
        {t('emailCaptureBanner.form.success.header')}
      </h2>
      <p className='mc-mt-2 mc-opacity--muted'>
        {descriptionText || t('emailCaptureBanner.form.success.description')}
      </p>
    </div>
  )
}

export default ThankYou
